import tableHelper from '@/services/tableHelper';
import http from '../services/http';
import { historicalArchiveFilters } from '../config';

const historicalArchive = {
  index(tableFilters, filterStatus) {
    const filters = tableHelper.whereFilters(filterStatus, historicalArchiveFilters);
    return http.request({
      method: 'get',
      url: '/historic-reports',
      params: { filter: { ...tableFilters, where: filters } },
    });
  },
  count(filterStatus) {
    const where = tableHelper.whereFilters(filterStatus, historicalArchiveFilters);
    return http.request({
      method: 'get',
      url: '/historic-reports/count',
      params: { where },
    });
  },
  downloadReport(id) {
    return http.request({
      method: 'get',
      url: `/historic-reports/${id}/download`,
      responseType: 'blob',
    });
  },
};

export default historicalArchive;
